import React, { useContext, useEffect, useState } from 'react';
import { fetchAPIDataWhileSettingState, generateClassName } from '../../b2b-common/helpers';
import NewImageForm from '../../b2b-common/NewImageForm';
import ElementsCarousel from '../../b2b-common/ElementsCarousel';
import { extractFrameworkImageParams, getImagesWithActions, isValidFrameworkImagePath } from './helper';
import { LoginContext } from '../../../App';
import { deleteFrameworkImage, fetchFrameworkData, uploadFrameworkImage } from '../../../services/b2b-frameworks-apiService';

const FrameworkImages = ({ frameworkSuite, framework, className = null }) => {
    const { loginData } = useContext(LoginContext);
    const [currentFramework, setCurrentFramework] = useState(framework);

    useEffect(() => {
        setCurrentFramework(framework);
    }, [framework]);

    const updateFramework = async () => {
        const paramsArray = [
            frameworkSuite,
            currentFramework.frameworkId,
            loginData.accessToken,
            0,      // depth
            true,  // fwAddImages
            false,  // levelNsAddImages
        ];
        const fw = await fetchAPIDataWhileSettingState(fetchFrameworkData, paramsArray, null);
        setCurrentFramework(fw);
    }

    const handleDeleteFrameworkImage = async (image) => {
        //console.log('Delete image:', image);
        //console.log('Is Valid;', isValidFrameworkImagePath(image));
        //console.log('Image params:', extractImageParams(image));
        const deleteParams = extractFrameworkImageParams(image);
        try {
            await deleteFrameworkImage(frameworkSuite, currentFramework.frameworkId, loginData.accessToken, deleteParams);
            await updateFramework();
        } catch (error) {
            console.error('Failed to delete framework image:', error.message);
            alert('Failed to delete framework image. Please try again.');
        }
    }

    const handleFrameworkImageUpload = async (file, imageFields) => {
        //console.log(file, imageFields);
        try {
            await uploadFrameworkImage(frameworkSuite, currentFramework.frameworkId, file, loginData.accessToken, imageFields);
            await updateFramework();
        } catch (error) {
            console.error('Failed to upload framework image:', error.message);
            alert('Failed to upload framework image. Please try again.');
        }
    }

    //console.log('Current framework:', currentFramework);

    return (
        (currentFramework &&
            <div className={generateClassName("fw-images", "container", className)}>
                <NewImageForm defaultImageName={"fw_Image"} onImageUpload={handleFrameworkImageUpload} />
                <ElementsCarousel
                    elements={getImagesWithActions(currentFramework, null, handleDeleteFrameworkImage, "framework-images")}
                    onElementSelect={null}
                    className={"levelNs-images-carousel"}
                />
            </div>
        )
    );
};

export default FrameworkImages;